import {DatePicker, Button} from 'antd';
import {Moment} from "moment/moment";
import moment from "moment";
import {useEffect, useState} from "react";
import type { RangePickerProps } from 'antd/es/date-picker';
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router";

const {RangePicker} = DatePicker;

type Props = {
  loading: boolean,
  dateFormat: string,
  dates: [Moment, Moment],
  dateChange: (val: any) => void,
  search: () => void
}

const CashDateItem = ({loading, dateFormat, dates, dateChange, search}: Props) => {

  const [newDates, setDate] = useState<[Moment, Moment]>(dates)

  const {t} = useTranslation();

  const { state } = useLocation();


  useEffect(() => {
    if(state?.date_item_start && state?.date_item_end) {
      setDate([
        moment(new Date(state.date_item_start)),
        moment(new Date(state.date_item_end)),
      ])
      dateChange([moment(new Date(state.date_item_start)), moment(new Date(state.date_item_end))])
    }
  },[])

  const selectDateChange: RangePickerProps['onChange'] = (dates, dateStrings) => {
    if (dates) {
      setDate([dates[0] ?? moment(), dates[1] ?? moment()])
      dateChange([dates[0] ?? moment(), dates[1] ?? moment()])
    }
  };

  const today = () => {
    setDate([moment(), moment()])
    dateChange([moment(), moment()])
    // search()
  }

  const yesterday = () => {
    const yesterday = moment().subtract(1, 'days');
    setDate([yesterday, yesterday])
    dateChange([yesterday, yesterday])
    // search()
  }

  const thisWeek = () => {
    const startOfWeek = moment().startOf('isoWeek');
    setDate([startOfWeek, moment()])
    dateChange([startOfWeek, moment()])
    // search()
  }

  const lastWeek = () => {
    const startOfLastWeek = moment().subtract(1, 'weeks').startOf('isoWeek')
    const endOfLastWeek = moment().subtract(1, 'weeks').endOf('isoWeek')
    setDate([startOfLastWeek, endOfLastWeek])
    dateChange([startOfLastWeek, endOfLastWeek])
    // search()
  }

  const thisMonth = () => {
    const startOfMonth = moment().startOf('month')
    setDate([startOfMonth, moment()])
    dateChange([startOfMonth, moment()])
    // search()
  }

  const lastMonth = () => {
    const startOfLastMonth = moment().subtract(1, 'months').startOf('month')
    const endOfLastMonth = moment().subtract(1, 'months').endOf('month')
    setDate([startOfLastMonth, endOfLastMonth])
    dateChange([startOfLastMonth, endOfLastMonth])
    // search()
  }


  return (
      <div>
        <RangePicker
            value={newDates}
            defaultValue={newDates}
            format={dateFormat}
            onChange={selectDateChange}
            style={{ width: 230 }}
        />
        <Button onClick={search} loading={loading} type="primary" shape='round' className='rounded ml-3'>{t('search')}</Button>
        <Button onClick={today} type="primary" shape='round' className='rounded ml-3'>{t('today')}</Button>
        <Button onClick={yesterday} type="primary" shape='round' className='rounded ml-3'>{t('yesterday')}</Button>
        <Button onClick={thisWeek} type="primary" shape='round' className='rounded ml-3'>{t('this_week')}</Button>
        <Button onClick={lastWeek} type="primary" shape='round' className='rounded ml-3'>{t('last_week')}</Button>
        <Button onClick={thisMonth} type="primary" shape='round' className='rounded ml-3'>{t('this_month')}</Button>
        <Button onClick={lastMonth} type="primary" shape='round' className='rounded ml-3'>{t('last_month')}</Button>
      </div>
  )
}

export default CashDateItem;